import { Autocomplete, Button, Grid, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { getTrabajadores, postEvento } from '../../../services/apis';

export const FormLimpiezas = ({ tEventoSelec, fecha, cargarEventos, cerrarFormulario }) => {

    const [opTrabajadores, setOpTrabajadores] = useState([]);
    const [trabajadoresSelec, setTrabajadoresSelec] = useState([]);
    const [horaInicio, setHoraInicio] = useState();

    const [nuevaLimpieza, setNuevaLimpieza] = useState({
        usuarioEncargado: null,
        id_usuarios_encargados: [],
        horaInicio: horaInicio,
        fecha: fecha,
        asunto: null,
        descripcion: null,
        id_tipoEvento: null,
    })

    const cargarTrabajadores = async () => {
        try {
            const response = await getTrabajadores();
            const tmp = [...response.data];
            const newTmp = tmp.map((item, index) => ({
                label: item.nombre,
                value: item.id
            }))
            setOpTrabajadores(newTmp);
        } catch (error) {
            console.error("Error en carregar usuaris", error)
        }
    }

    const crearLimpieza = async (nuevaLimpieza) => {

        let fechaFomat = "";
		const [dia, mes, anio] = fecha.split('-');
		fechaFomat = `${anio}-${mes}-${dia}`;


        nuevaLimpieza.asunto = 'Neteja';
        nuevaLimpieza.descripcion = 'Neteja';
        nuevaLimpieza.usuarioEncargado = trabajadoresSelec[0]?.value || null;
        nuevaLimpieza.id_usuarios_encargados = trabajadoresSelec.map((trabajador) => trabajador.value);
        nuevaLimpieza.horaInicio = horaInicio;
        nuevaLimpieza.fecha = fechaFomat;
        nuevaLimpieza.id_tipoEvento = 2;


        try {
            const resposne = await postEvento(nuevaLimpieza);
            console.log("Esdeveniment creat:", resposne);
            if (resposne.success) {

                cargarEventos();
                cerrarFormulario();
            }


        }
        catch (error) {
            console.error("Error en crear l'esdeveniment:", error);
        }
    };

    useEffect(() => {
        cargarTrabajadores();
    }, []);

    return (
        <Grid
            container
            direction="row"
            spacing={2}
			className="ki-section-row-center events-create-section events-type-cleaning"
                size={{ xs: 12 }}
                sx={{ display: tEventoSelec == 2 ? 'flex' : 'none' }}>
            <Grid size={{ xs: 11 }}>
                <Typography className="events-create-section-title">Neteja</Typography>
            </Grid>
            <Grid
                size={{ xs: 11 }}>
                <Autocomplete
                    multiple
                    disableCloseOnSelect
                    fullWidth
                    className={opTrabajadores ? "inputDateInput" : 'inputDateInput-empty'}
                    disablePortal
                    id="combo-box-demo"
                    options={opTrabajadores}
                    value={trabajadoresSelec}
                    onChange={(event, newValue) => setTrabajadoresSelec(newValue)}
                    renderInput={(params) => <TextField {...params} label="Usuaris encarregats*" />}
                />
            </Grid>

            <Grid
                size={{ xs: 11 }}>
                <TextField
                    fullWidth
                    label="Hora d'inici"
                    type="time"
                    value={horaInicio || ""}
                    onChange={(e) => setHoraInicio(e.target.value)}
                    InputLabelProps={{
                        shrink: true, // perquè l'etiqueta no se solape
                    }}
                />
            </Grid>

            <Grid
                size={{ xs: 11 }}>
                <Button variant='contained' fullWidth onClick={() => crearLimpieza(nuevaLimpieza)}>
                    Crear neteja
                </Button>
            </Grid>
        </Grid>

    )
}
